import { COMMON_DATE_FORMAT, COMMON_DATETIME_FORMAT } from 'constants/date';
import { FieldInputType } from 'constants/fields';

export const closingInformationFields = {
  anticipatedClosingDate: {
    label: 'Anticipated Closing Date:',
    name: 'anticipatedClosingDate',
    type: FieldInputType.DATE,
    format: COMMON_DATE_FORMAT,
    options: { includeLocalOffset: false },
  },
  firstCloseAt: {
    label: 'First Closing Date and Time:',
    name: 'firstCloseAt',
    type: FieldInputType.DATE,
    format: COMMON_DATETIME_FORMAT,
    options: { includeLocalOffset: true },
  },
  closeAt: {
    label: 'Closing Date and Time:',
    name: 'closeAt',
    type: FieldInputType.DATE,
    format: COMMON_DATETIME_FORMAT,
    options: { includeLocalOffset: true },
  },
  location: {
    contentValueClassName: 'truncate',
    label: 'Closing Location:',
    name: 'location',
    type: FieldInputType.TEXT,
  },
  interestCreditNoteDate: {
    label: 'Note Date:',
    name: 'prepaidInterestCreditData.interestCreditNoteDate',
    type: FieldInputType.DATE,
    format: COMMON_DATE_FORMAT,
    options: { includeLocalOffset: false },
  },
  interestCreditRescissionDate: {
    label: 'Rescission Date:',
    name: 'prepaidInterestCreditData.interestCreditRescissionDate',
    type: FieldInputType.DATE,
    format: COMMON_DATE_FORMAT,
    options: { includeLocalOffset: false },
  },
  interestCreditFundingDate: {
    label: 'Funding Date:',
    name: 'prepaidInterestCreditData.interestCreditFundingDate',
    type: FieldInputType.DATE,
    format: COMMON_DATE_FORMAT,
    options: { includeLocalOffset: false },
  },
  interestCreditDisbursementDate: {
    label: 'Disbursement Date:',
    name: 'prepaidInterestCreditData.interestCreditDisbursementDate',
    type: FieldInputType.DATE,
    format: COMMON_DATE_FORMAT,
    options: { includeLocalOffset: false },
  },
  interestCreditFirstPaymentDate: {
    label: 'First Payment Date:',
    name: 'prepaidInterestCreditData.interestCreditFirstPaymentDate',
    type: FieldInputType.DATE,
    format: COMMON_DATE_FORMAT,
    options: { includeLocalOffset: false },
  },
  approvalDate: {
    label: 'Approval Date:',
    name: 'approvalDate',
    type: FieldInputType.DATE,
    format: COMMON_DATE_FORMAT,
    options: { includeLocalOffset: false },
  },
  approvalExpirationDate: {
    label: 'Approval Expiration Date:',
    name: 'approvalExpirationDate',
    type: FieldInputType.DATE,
    format: COMMON_DATE_FORMAT,
    options: { includeLocalOffset: false },
  },
  maturityDate: {
    label: 'Maturity Date:',
    name: 'maturityDate',
    type: FieldInputType.DATE,
    format: COMMON_DATE_FORMAT,
    options: { includeLocalOffset: false },
  },
};
